<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row no-gutters>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
        <TopSpacePeople page="guests"/> 
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? ' mx-auto d-flex justify-end' : 'mx-auto'"
      >
        <SearchBarExpanding v-if="!(users && users.length == 0 && usersInfo.currentPage == 1 && !loadingData && !loadingClear && search == null && startDateFilter == null && endDateFilter == null)" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="users && users.length == 0 && usersInfo.currentPage == 1 && !loadingData && !loadingClear && search == null && startDateFilter == null && endDateFilter == null"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptySpaceGuestsPageTitle')"
          :page-text="$t('emptySpaceGuestsPageText')"
          page-image="image1"
        />
      </v-col>
    </v-row>

    <v-row
      v-else
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto pa-0"
        :class="{ 'd-block': mobile(), 'd-flex mt-6': !mobile() && role != 'space_admin', 'd-flex mb-n3 mt-3': !mobile() && role == 'space_admin'}"
      >
        <div v-if="!loadingData && role == 'space_admin'" class="d-flex flex-wrap align-center">
          <v-checkbox
            v-model="selectedAll"
            @change="selectAllUsersFromPage($event)"
            :disabled="users.length == 0"
          ></v-checkbox>
          <v-menu
              offset-y
              rounded-lg
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="no-hover ml-n3"
                  :ripple="false"
                >
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list
                class="menulist-drawer"
                data-testid="menu-list"
              >
                <v-list-item @click="selectedAll = true, selectAllUsersFromPage(true)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('allFromThisPage') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedAll = false, selectAllUsersFromPage(false)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('removeUsersNone') }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-btn 
            ref="submit"
            data-testid="remove-from-space-button"
            type="submit"
            color="accent"
            min-width="100"
            elevation="0"
            class="rounded-xxl text-none px-4 submit ml-3" 
            @click.stop="showConfirmationDialogRemoveFromSpace"
            :disabled="selectedUsersForRemoving.length == 0"
            :loading="loadingRemovingMultipleUsers"
          >
            {{ $t('removeFromSpace') }}
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <DateFilterPeople v-if="!loadingData" @dateFilter="dateFilter" class="d-flex flex-wrap align-center justify-end"/>
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                v-if="role == 'space_admin'"
                cols="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-3"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col 
                :cols= "role == 'space_admin' ? '10' : '11'"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      data-testid="view-profile"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        viewedUser = user,
                        dialogVisibleViewProfile = true, 
                        confirmationDialogTitle = 'User profile'"
                    >
                      <v-list-item-title>{{ $t('viewUserProfile') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="promote-guest-to-space-member"
                      router
                      @click="promoteToSpaceMember(user)"
                    >
                      <v-list-item-title>{{ $t('promoteToSpaceMember') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role == 'space_admin'"
                      data-testid="remove-space-member"
                      router
                      @click.stop="
                        selectedUserForDeletion = user
                        dialogVisibleRemoveSpaceMember = true,
                        confirmationDialogTitle = $t('confirmationDialogTitleRemoveMember'),
                        confirmationDialogText = $t('confirmationDialogTextRemoveMember'),
                        confirmationDialogSubmitBtn = $t('removeSpaceMember')
                        confirmationDialogCancelBtn = $t('no')"
                    >
                      <v-list-item-title>{{ $t('removeSpaceMember') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile() && role == 'space_admin'">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-4"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col
                md="4"
                lg="5"
                class="d-flex justify-left align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
                <div class="ml-3">
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('name') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </div>
                </div>
              </v-col>
              <v-col
                md="4"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>
              <v-col 
                md="2" 
                lg="1" 
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('lastLogin') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ format_date(user.attributes.last_login_at) }}
                </div>
              </v-col>
              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        x-large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      data-testid="view-profile"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        viewedUser = user,
                        dialogVisibleViewProfile = true, 
                        confirmationDialogTitle = 'User profile'"
                    >
                      <v-list-item-title>{{ $t('viewUserProfile') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="promote-guest-to-space-member"
                      router
                      @click="promoteToSpaceMember(user)"
                    >
                      <v-list-item-title>{{ $t('promoteToSpaceMember') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="remove-space-member"
                      router
                      @click.stop="
                        selectedUserForDeletion = user
                        dialogVisibleRemoveSpaceMember = true, 
                        confirmationDialogTitle = $t('confirmationDialogTitleRemoveMember'), 
                        confirmationDialogText = $t('confirmationDialogTextRemoveMember'), 
                        confirmationDialogSubmitBtn = $t('removeSpaceMember')
                        confirmationDialogCancelBtn = $t('no')"
                    >
                      <v-list-item-title>{{ $t('removeSpaceMember') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile() && role != 'space_admin'">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex justify-center align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>
              <v-col
                md="4"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>
              <v-col
                md="4"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>
               <v-col 
                md="2" 
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('lastLogin') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ format_date(user.attributes.last_login_at) }}
                </div>
              </v-col>
              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        x-large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      data-testid="view-profile"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        viewedUser = user,
                        dialogVisibleViewProfile = true, 
                        confirmationDialogTitle = 'User profile'"
                    >
                      <v-list-item-title>{{ $t('viewUserProfile') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="promote-guest-to-space-member"
                      router
                      @click="promoteToSpaceMember(user)"
                    >
                      <v-list-item-title>{{ $t('promoteToSpaceMember') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDialog
      v-if="dialogVisibleRemoveSpaceMember"
      ref="confirmationDialogRemoveSpaceMember"
      :visible="dialogVisibleRemoveSpaceMember"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-remove-space-member"
      @close="dialogVisibleRemoveSpaceMember=false, selectedUserForDeletion = null, confirmationDialogAdditonalText = ''"
      @proceedSubmit="selectedUserForDeletion != null ? removeSpaceMember(selectedUserForDeletion) : removeSpaceMembers()"
    />
    <ViewUserProfileDialog
      v-if="dialogVisibleViewProfile"
      :visible="dialogVisibleViewProfile"
      :cd-title="confirmationDialogTitle"
      :selected-role="selectedRole.split(' ').join('_')"
      :viewed-user="viewedUser"
      data-testid="view-user-profile-dialog"
      @close="dialogVisibleViewProfile=false"
    />
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />

    <!-- <PlusButtonWithLink data-testid="space-guests-button" rounded="xxl" :link="link" /> -->
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getSpaceGuests, promoteGuestToSpaceMember, removeSpaceMember, searchInSpaceGuests, removeSpaceMembers } from '../../api/spaceApi'
import Pagination from '../../components/Pagination'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import ViewUserProfileDialog from '../../components/ViewUserProfileDialog'
// import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import TopSpacePeople from './TopSpacePeople'
import SearchBarExpanding from '../../components/SearchBarExpanding'
import moment from 'moment'
import DateFilterPeople from '../../components/DateFilterPeople'

export default {
    components: {
        Pagination,
        // PlusButtonWithLink,
        EmptyPage,
        AlertMessages,
        ConfirmationDialog,
        ViewUserProfileDialog,
        TopSpacePeople,
        SearchBarExpanding,
        DateFilterPeople
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: { 
                currentPage: 1,
                total: 0,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            link: {title: '', route: '/audiences/guests'},
            loadingData: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            selectedUserForDeletion: null,
            dialogVisibleRemoveSpaceMember: false,
            search: null,
            paginationKey: '',
            dialogVisibleViewProfile: false,
            selectedUsersForRemoving: [],
            selectedAll: false,
            notSelected: false,
            selected: true,
            confirmationDialogAdditonalText: '',
            visitedUsers: [],
            removeFromConnectedActivities: false,
            loadingRemovingMultipleUsers: false,
            totalUsers: 0,
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            startDateFilter: null,
            endDateFilter: null,
            loadingClear: false
        }
    },
    watch:{
      selectedUsersForRemoving(){
        if(this.selectedUsersForRemoving.length == 0){
          this.selectedAll = false
        }else{
          this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
        }
      }
    },
    async created(){
        this.loadingData = true
        await this.fetchUsers()
        this.loadingData = false
    },
    methods:{
        async searchPeople(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchInSpaceGuests(this.spaceId,keyword,this.pageNumber, this.size, this.startDateFilter, this.endDateFilter)
                  if(response){
                      if(response.status == 200){
                        this.selectedUsersForRemoving = []
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.searchPeople(keyword)
                        }else {
                          this.usersInfo = response.data.meta
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          this.visitedUsers.push(...response.data.data)
                          window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchUsers()
          this.search = null
          this.paginationKey = Date.now()
          return
        },
        async handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              await this.fetchUsers()
            }else {
              await this.searchPeople(this.search)
            }
            this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
        },
        async fetchUsers(){
            try {
                const response = await getSpaceGuests(this.spaceId, this.pageNumber, this.size, this.startDateFilter, this.endDateFilter)
                if(response.status){
                    this.users = response.data.data
                    this.permissions = response.data.meta.permissions
                    if(this.users.length == 0 && response.data.meta.total > 0){
                        this.pageNumber = 1
                        await this.fetchUsers()
                    }else {
                        this.usersInfo = response.data.meta
                        this.totalUsers = response.data.meta.total
                        if(this.pageNumber == 1){
                          this.paginationKey = Date.now()
                        }
                        this.visitedUsers.push(...response.data.data)
                        window.scrollTo(0,0)
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async promoteToSpaceMember(user){
            try {
                let data = {
                    data: {
                        type: "spaces",
                        id: this.spaceId, 
                        attributes: {
                            'user_id': user.id,
                        }
                    }
                }
                const response = await promoteGuestToSpaceMember(this.spaceId, data)
                if(response.status){
                    if(response.status == 200) {
                        if(this.search == null){
                            await this.fetchUsers()
                        }else {
                            await this.searchInSpaceGuests(this.search)
                        }
                        this.alertValue = true
                        this.alertType = 'success'
                        this.alertMsg =  i18n.t('promoteToSpaceMemberSuccess')
                        this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                              this.alertValue = true
                              this.alertType = 'error'
                              this.alertMsg =  i18n.t('serverError') 
                            
                        })
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeSpaceMember(user){
            this.dialogVisibleRemoveSpaceMember = false
            try {
                let data = {
                    data: {
                        type: "spaces",
                        attributes: {
                            'user_id': user.id,
                        }
                    }
                }
                const response = await removeSpaceMember(this.spaceId, data)
                if(response.status){
                    if(response.status == 200) {
                        if(this.search == null){
                            await this.fetchUsers()
                        }else {
                            await this.searchInSpaceGuests(this.search)
                        }
                        this.selectedUsersForRemoving = []
                        this.confirmationDialogAdditonalText = ''

                        this.alertValue = true
                        this.alertType = 'success'
                        this.alertMsg =  i18n.t('removeSpaceMemberSuccess')
                        this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                              this.alertValue = true
                              this.alertType = 'error'
                              this.alertMsg =  i18n.t('serverError') 
                            
                        })
                    }
                }
            } catch (e) {
                this.dialogVisibleRemoveSpaceMember = false
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
            this.selectedUserForDeletion = null
        },
        async removeSpaceMembers(){
            this.dialogVisibleRemoveSpaceMember = false
            this.loadingRemovingMultipleUsers = true
            try {
                let data = {
                    data: {
                        type: "spaces",
                        attributes: {
                            users: this.selectedUsersForRemoving
                        }
                    }
                }
                const response = await removeSpaceMembers(this.spaceId, data)
                if(response.status){
                    if(response.status == 200) {
                        if(this.search == null){
                          await this.fetchUsers()
                        }else {
                          await this.searchInSpaceGuests(this.search)
                        }
                        this.selectedUsersForRemoving = []
                        this.confirmationDialogAdditonalText = ''
                        this.alertValue = true
                        this.alertType = 'success'
                        this.alertMsg =  i18n.t('removeUsersFromSpaceSuccess')
                        this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError') 
                        })
                    }
                }
            } catch (e) {
                if(e.response){
                    this.confirmationDialogAdditonalText = ''
                    if (e.response.status == 403){
                       this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
            this.loadingRemovingMultipleUsers = false
        },
        selectAllUsersFromPage(event){
          if(event){
            this.users.forEach(user => {
              if(!this.selectedUsersForRemoving.includes(user.id)){
                this.selectedUsersForRemoving.push(user.id)
              }
            })
          }else {
            this.users.forEach(user => {
              this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
            })
          }
        },
        selectUser(event, user){
          if(event){
            if(!this.selectedUsersForRemoving.includes(user.id)){
              this.selectedUsersForRemoving.push(user.id)
            }
          }else{
            this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
          }
        },

        showConfirmationDialogRemoveFromSpace(){
          this.selectedUsersForRemoving.forEach(item => {
            const user = this.visitedUsers.find(user => user.id == item)
            this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">' + user.attributes.first_name + ' ' + user.attributes.last_name + '</p>'
          });
          this.dialogVisibleRemoveSpaceMember= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleRemoveUsersFromSpace')
          this.confirmationDialogText= i18n.t('confirmationDialogTextRemoveUsersFromSpace')
          this.confirmationDialogSubmitBtn= i18n.t('remove')
          this.confirmationDialogCancelBtn= i18n.t('no')
        },

        format_date(value){
          if (value) {
            return moment(String(value)).format('YYYY-MM-DD')
          }
        },

        async dateFilter(startDate, endDate){
          this.loadingClear = true
          this.startDateFilter = startDate
          this.endDateFilter = endDate
          if(this.search == null){
            await this.fetchUsers()
          }else{
            await this.searchPeople(this.search)
          }
          this.loadingClear = false
        }
    }
}
</script>
